import styled from "@material-ui/core/styles/styled";

const ContentWrapper_List = styled("div")({
  // marginTop: "16px",
  // padding: "24px",
  backgroundColor: "#ffffff",
  width: "100%",
  border: "1px solid #dee2e6 !important",
  borderRadius: "5px",
  position:'relative',    //fee add Parallax  footer
  zIndex:2,             //fee add Parallax footer
  marginBottom:'130px',     //fee add Parallax footer
});
export const FormWrapper = styled("div")({
  paddingTop: 0,
  paddingBottom: 0,
});

export const FormButtons = styled("div")({
  paddingTop: "16px",
  display: "flex",

  "& > *": {
    marginRight: "8px",
    marginBottom: "8px",
  },
});

export default ContentWrapper_List;
